import type { DocMigration } from "../docMigration";

function isFormula(v: any): boolean {
  return !!v && typeof v === "object" && v.hasOwnProperty("type") && v.type === "FORMULA";
}

const migration: DocMigration = {
  id: "20260429_remove_option_set_disabled_formulas",
  description: "Removes disabled formulas from option sets",
  apply(json: any) {
    for (const id in json.optionSets) {
      const optionSet = json.optionSets[id];
      if (isFormula(optionSet.disabled)) {
        optionSet.disabled = false; // default behavior for newly created option sets
      }
    }
    return json;
  },
};

export default migration;
